module.exports = __webpack_public_path__ + "img/output_10.f4cdecc2.png";